import { apiBaseURL } from "../ProjectConstants";

/*
 =-=-=-=-=- data structure -=-=-=-=-=
    comment: string,
    orderId: int,  
    fetch: fetch from source,
        (maybe it could call it here)
 =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
*/
async function handlePostProvideAssist(comment, orderId, fetch) {
  const response = await fetch.post(
    `${apiBaseURL}/api/Approval/Assist?orderId=${orderId}&comment=${comment}`,
  );
  const isDataGood =
    response?.success &&
    response?.data?.statusCode &&
    response?.success !== "Invalid Model";
  console.log("handlePostProvideAssist: orderId, comment", orderId, comment);
  console.log("handlePostProvideAssist response", response);

  return {
    response,
    isDataGood,
  };
}
export default handlePostProvideAssist;
